/** Shared Radix select styling — aligned with ListPage filter controls (/prestataires). */
export const selectTriggerClassName =
    "h-11 w-full touch-manipulation cursor-pointer justify-between gap-2 rounded-[10px] border border-gray-200 bg-white px-4 text-left text-sm font-normal text-neutral-950 shadow-none hover:bg-gray-50 hover:text-neutral-950 focus:ring-2 focus:ring-ring focus:ring-offset-0 data-[placeholder]:text-muted-foreground";

export const selectContentClassName =
    "max-h-72 rounded-2xl border border-input bg-popover py-1.5 text-sm text-popover-foreground shadow-lg ring-1 ring-border/40";

export const selectItemClassName = "rounded-xl py-2 pl-8 pr-3";
